/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NextAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function NextAction({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/NextAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let questionIsValidValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'isValid',
})
let questionRequiredValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'required',
})
let questionHideNextValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'hideNext',
})
let questionIdValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'id',
})
let aggregateData = fromHelpers.getView(questionIsValidValueData, questionRequiredValueData, questionHideNextValueData, questionIdValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}